import { GenericError } from './genericError.mjs';

class HttpBadStatusCodeError extends GenericError {
    statusCode;
    constructor(params, _statusCode, _domain) {
        let message;
        let domain;
        let details;
        if (typeof params === 'string') {
            message = params;
            domain = _domain;
        }
        else {
            message = params.message;
            domain = params.domain;
            details = params.details;
        }
        super({ type: 'BadStatusCodeError', domain: domain || 'unknown-domain.by-peperrors', message, details });
        if (typeof params === 'string') {
            this.statusCode = _statusCode;
        }
        else {
            this.statusCode = params.statusCode;
        }
        Object.setPrototypeOf(this, HttpBadStatusCodeError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HttpBadStatusCodeError);
        }
        else {
            this.stack = new Error().stack;
        }
    }
}

export { HttpBadStatusCodeError };
//# sourceMappingURL=httpBadStatusCodeError.mjs.map
